import React from "react";
import AppWrapper from "./../utils/global-context";
import Wizard from "./03-organisms/wizard/wizard";

const App = () => {
  return (
    <AppWrapper>
      <Wizard/>
    </AppWrapper>
  )
};

export default App;
